module.exports = __webpack_public_path__ + "img/gb9877_1-88-52x72x8.prt.3ca9c1d6.jpg";